export default "__VITE_ASSET__Bs4A9LNt__"